import { LoginPage } from "@/features/auth/pages/Login";
import { withGuest } from "@/hoc/withGuest";

const Login = () => {
  return <LoginPage />;
};

export default withGuest(Login);
